var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.clock.type == 'D')?_c('digital-clock',{attrs:{"clock":_vm.clock}}):(_vm.clock.type == 'A')?_c('analog-clock',{attrs:{"clock":_vm.clock}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }